/** Icônes distinctes pour les entrées du menu « Filtrer par ». */
const ICONS: Record<string, string> = {
  // Dashboard / N1
  territories:
    "M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11Zm0-9.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
  serviceIds:
    "M12 3c3 2 5 4.5 5 8a5 5 0 0 1-10 0c0-3.5 2-6 5-8Zm0 18V12m0 0c-2.5 0-4-1.5-4-3.5C10 8.5 12 10 12 12Zm0 0c2.5 0 4-1.5 4-3.5C14 8.5 12 10 12 12Z",
  indicateurIds: "M4 19V5m0 14h16M8 16v-5m4 5V8m4 8v-3",
  // Année / métrique (si proposés dans le menu)
  year: "M7 3v2m10-2v2M4 9h16M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z",
  metric: "M4 6h16M4 12h10M4 18h14",
  // Catalogues
  services:
    "M12 3c3 2 5 4.5 5 8a5 5 0 0 1-10 0c0-3.5 2-6 5-8Zm0 18V12m0 0c-2.5 0-4-1.5-4-3.5C10 8.5 12 10 12 12Zm0 0c2.5 0 4-1.5 4-3.5C14 8.5 12 10 12 12Z",
  indicateurs: "M4 19V5m0 14h16M8 16v-5m4 5V8m4 8v-3",
  categories: "M4 7h16M4 12h16M4 17h10",
  availability: "M12 3 4.5 6.5v5.2c0 4.6 3.1 7.9 7.5 9.3 4.4-1.4 7.5-4.7 7.5-9.3V6.5L12 3Z",
  units: "M7 4h10v4H7V4Zm2 6h6v10H9V10Z",
  frequencies: "M12 6v6l4 2M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z",
  statuses: "M9 12l2 2 4-4M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z",
  qualites: "M12 3l2.5 5 5.5.8-4 3.9.9 5.5L12 15.8 7.1 18.2l.9-5.5-4-3.9 5.5-.8L12 3Z",
  emprise: "M3 7h18M6 7v13m12-13v13M9 11h6m-6 4h6",
  search: "M11 5a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm10 16-3.5-3.5",
};

const FALLBACK = "M3 5h18l-7 8v6l-4 2v-8L3 5Z";

export type FilterFieldIconProps = {
  readonly fieldKey: string;
  readonly size?: number;
};

export function FilterFieldIcon({ fieldKey, size = 16 }: FilterFieldIconProps) {
  const path = ICONS[fieldKey] ?? FALLBACK;
  return (
    <svg
      className="nbs-filter-pop__ico"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={path} />
    </svg>
  );
}
